import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Header_gaeste from './components/header_footer/header_gaeste.js';
import Footer from './components/header_footer/footer.js';

import { CartProvider } from './context/cartcontext.js';
import { AuthProvider } from './context/auth_context.js';

import Home from './pages/home.js';
import About_me from './pages/about_me.js';
import Kontakt from './pages/kontakt.js';
import Feedback from './pages/feedback.js';
import Login from './pages/login.js';
import Register from './pages/register.js';

import Body_tasche from './components/products/body_Tasche.js';
import Body_portmoney from './components/products/body_portmoney.js';
import Body_accessory from './components/products/body_accessory.js';
import Body_guertel from './components/products/body_guertel.js';
import Body_key from './components/products/body_keys.js';
import Body_handy from './components/products/body_handy.js';
import Body_sonstige from './components/products/body_sonstige.js';
import Body_cart from './components/products/body_cart.js';

import See_all_newProduct from './components/products/see_all_newProduct.js';
import See_all_moreBuys from './components/products/see_all_moreBuy.js';

import Body_forgot_password from './components/profile/forget_pass.js';
import Body_send_text from './pages/send-text.js';

import Body_kasse from './components/kasse.js';

import Impressum from './pages/impressum.js';
import Datenschutz from './pages/datenschutzt.js';
import ProductGallery from './pages/gallery.js';
import Feedback_text from './pages/feedback-text.js';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <Header_gaeste />
          <main style={{ padding: '40px' }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About_me />} />
              <Route path="/contact" element={<Kontakt />} />
              <Route path="/feedback" element={<Feedback />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              {/* Produkte */}
              <Route path="/products/tasche" element={<Body_tasche />} />
              <Route path="/products/portmoney" element={<Body_portmoney />} />
              <Route path="/products/accessory" element={<Body_accessory />} />
              <Route path="/products/guertel" element={<Body_guertel />} />
              <Route path="/products/key" element={<Body_key />} />
              <Route path="/products/sonstige" element={<Body_sonstige />} />
              <Route path="/products/handy" element={<Body_handy />} />

              {/* Sonstiges */}
              <Route path="/cart" element={<Body_cart />} />
              <Route path="/newProducts" element={<See_all_newProduct />} />
              <Route path="/more-buys" element={<See_all_moreBuys />} />
              <Route path="/forgot-password" element={<Body_forgot_password />} />
              <Route path="/send-text" element={<Body_send_text />} />
              <Route path="/feedback-text" element={<Feedback_text />} />
              <Route path="/kasse" element={<Body_kasse />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />

              {/* Produkt Detail-Galerie */}
              <Route path="/product/:product_id" element={<ProductGallery />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;        